import { aboutData } from "../utils";
import { motion } from "framer-motion";
import { plateVariants, fadeIn } from "../utils";

export const About = () => {
  const { pretitle, title, subtitle, image, btnText } = aboutData;

  return (
    <section className="min-h-[620px]">
      <div id='about'className="container mx-auto min-h-[620px]">
        <motion.div
          initial='hidden'
          whileInView='show'
          viewport={{ once: false, amount: 0.6 }}
          className="min-h-[620px] flex flex-col lg:flex-row items-center"
        >
          <motion.div variants={fadeIn('right', 'tween', 0.2, 1.8)} className="flex-1 text-center lg:text-left">
            <div className="pretitle">{pretitle}</div>
            <h2 className="h2 capitalize">{title}</h2>
            <p className="mb-8 max-w-[560px] text-justify">{subtitle}</p>
            <button className="btn captilize mx-auto lg:mx-0">{btnText}</button>
          </motion.div>

          <motion.div variants={plateVariants} className="-mb-[50px] -mr-[50px] z-10">
            <img src={image} alt="Plate" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
